import { ApiEngagementRule, ApiProject } from "@incendium/api";
import { engagementService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchEngagements = async (project: ApiProject) => {
  const engagements = await engagementService.engagementServiceListEngagements({
    projectId: project.id as number,
  });
  return engagements.results || [];
};

export const useEngagements = () => {
  const { state, setState } = useProjectSharedState<ApiEngagementRule[]>(
    "engagements",
    [],
    fetchEngagements
  );

  return {
    engagements: state,
    setEngagements: setState,
  };
};
